import { get, patch, post, remove } from '@/api/base'

const ordersApi = {
  /**
   * Fetch a single order
   * @param {string} orderUuid - uuid of order to fetch
   */
  get: async orderUuid => {
    const response = await get({
      path: `orders/${orderUuid}`,
    })
    return response.success ? response.data.order : null
  },
  getPage: async ({ companyUuid, filter, page, options }) => {
    const response = await get({
      path: 'orders',
      params: {
        ...filter,
        company_uuid: companyUuid,
        container_uuid: filter.containerUuid,
        page,
      },
      options,
    })
    return response.success
      ? {
          ...response,
          orders: response.data.orders,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  create: async params => {
    return await post({ path: 'orders', params })
  },
  update: async (orderUuid, params) => {
    return await patch({ path: `orders/${orderUuid}`, params })
  },
  updateStatus: async ({ orderUuid, newStatus }) => {
    const response = await patch({ path: `orders/${orderUuid}/transition_status/${newStatus}` })

    return response.success && response.data.order
  },
  delete: async orderUuid => {
    return await remove({ path: `orders/${orderUuid}` })
  },
}

export const ORDER_TYPE = {
  EMPTYING: 'EmptyingOrder',
  FREE_SWITCHING: 'FreeSwitchingOrder',
  GATHERING: 'GatheringOrder',
  GATHERING_PICKUP: 'GatheringPickupOrder',
  OVERHEAD_LOADING: 'OverheadLoadingOrder',
  PICKUP_AND_WEIGH: 'PickupAndWeighOrder',
  PICKUP: 'PickupOrder',
  POSITIONING: 'PositioningOrder',
  SWITCHING: 'SwitchingOrder',
}

export const ORDER_TYPE_OPTIONS = [
  { label_i18n: 'meta.orderTypes.emptying', value: ORDER_TYPE.EMPTYING },
  { label_i18n: 'meta.orderTypes.gathering', value: ORDER_TYPE.GATHERING },
  { label_i18n: 'meta.orderTypes.gatheringPickup', value: ORDER_TYPE.GATHERING_PICKUP },
  { label_i18n: 'meta.orderTypes.freeSwitching', value: ORDER_TYPE.FREE_SWITCHING },
  { label_i18n: 'meta.orderTypes.overheadLoading', value: ORDER_TYPE.OVERHEAD_LOADING },
  { label_i18n: 'meta.orderTypes.pickup', value: ORDER_TYPE.PICKUP },
  { label_i18n: 'meta.orderTypes.pickupAndWeigh', value: ORDER_TYPE.PICKUP_AND_WEIGH },
  { label_i18n: 'meta.orderTypes.positioning', value: ORDER_TYPE.POSITIONING },
  { label_i18n: 'meta.orderTypes.switching', value: ORDER_TYPE.SWITCHING },
]

export default ordersApi
